<template>
  <div>
    <h3 class="text-xl lg:text-[28px] font-semibold text-strongest mb-3">Selected Rollover</h3>
    <Table
      :table_headers="rollover_table_headers"
      :table_data="[purchaseFlowStore.selected_rollover]"
      variant="secondary"
      :has_actions="true"
      :fields_with_custom_styles="['maturity_date', 'rollover_available']"
      mobile_primary_field="rollover_available"
      :column_gap_px="20"
    >
      <template v-slot:maturity_date="entry">
        <div>
          {{
            Math.max(
              0,
              Math.floor((new Date(entry.row.maturity_date) - new Date()) / (1000 * 60 * 60 * 24))
            )
          }}
          days
        </div>
      </template>
      <template v-slot:rollover_available="entry">
        <div>
          <p class="font-medium text-success">
            {{ formatCurrency(entry.row.rollover_available) }}
          </p>
        </div>
      </template>
      <!-- Only escape hatch off the reinvestment path — for investors whose intent
           is actually new capital rather than rolling the matured investment over. -->
      <template v-slot:actions>
        <Button variant="paper-primary" size="sm" @click="cancelRollover" is-icon-only-on-mobile>
          <template #icon>
            <Icon name="X" class="w-4 h-4" />
          </template>
          <template #label> Cancel </template>
        </Button>
      </template>
    </Table>
  </div>
</template>

<script setup>
import { usePurchaseFlowStore } from "@/stores";
import { Table, Button, Icon } from "@/components";

const purchaseFlowStore = usePurchaseFlowStore();

let rollover_table_headers = [
  {
    label: "Available for Reinvestment",
    field_name: "rollover_available",
    field_type: "number",
    number_type: "currency",
  },
  {
    label: "Amount at maturity",
    field_name: "amount_at_maturity",
    field_type: "number",
    number_type: "currency",
  },
  { label: "Time Until Maturity", field_name: "maturity_date", field_type: "date" },
  { label: "Type", field_name: "type" },
  {
    label: "Amount Reinvested",
    field_name: "amount_reinvested",
    field_type: "number",
    number_type: "currency",
  },
];

function formatCurrency(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

// Drop the reinvestment and continue as a brand new (new capital) investment.
// saveInvestmentProgress clears is_rollover / parent_investment / effective_date and
// flips payment_method off "Existing Investment" once selected_rollover is gone.
async function cancelRollover() {
  purchaseFlowStore.selected_rollover = null;
  await purchaseFlowStore.saveInvestmentProgress();
}
</script>
